import React from 'react';

import CardAccountFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/CardAccountFilter';
import CardDateRangeFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/CardDateRangeFilter';
import CurrencyFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/shared/CurrencyFilter';
import SearchFilter from 'pages/company/BankFeedRoute/components/FilterToolbar/shared/SearchFilter';
import ToolbarShell from 'pages/company/BankFeedRoute/components/FilterToolbar/shared/ToolbarShell';

// Credit Card tab toolbar: single-value card filter + shared currency / search, plus the async
// payment-date filter (DA-19485) that replaces the shared preset DateRangeFilter on this tab only.
// The Bank composition keeps DateRangeFilter untouched.
const CardFilterToolbar: React.FC = () => (
  <ToolbarShell>
    <CardAccountFilter />
    <CurrencyFilter />
    <CardDateRangeFilter />
    <SearchFilter />
  </ToolbarShell>
);

export default CardFilterToolbar;
